/**
 * License Plate / Handling Unit (LPN) — WMS UoM arc, Phase B.
 *
 * One table, two faces:
 * - PACK: a received pallet/case bound to a product + lot, carrying its
 *   point-in-time `units_per_pack`. Dies (CONSUMED) when broken to loose stock.
 * - CONTAINER: a vessel (picking cart, tote, consolidation pallet) holding
 *   heterogeneous content; PERMANENT (fixed cart #5) or TEMPORARY (per wave).
 *   Behaves as a mobile location — its own `location_id` is its current position.
 *
 * LPNs are an OPTIONAL overlay: stock can live with or without one (loose).
 */

export enum LpnType {
  PACK = 'PACK',
  CONTAINER = 'CONTAINER',
}

export enum LpnPersistence {
  /** Fixed, reusable container (e.g. cart #5) — its code survives cycles. */
  PERMANENT = 'PERMANENT',
  /** Allocated per wave/order, freed afterwards. */
  TEMPORARY = 'TEMPORARY',
}

export enum LpnStatus {
  /** A live PACK holding stock. */
  ACTIVE = 'ACTIVE',
  /** A container available to be filled. */
  FREE = 'FREE',
  /** A container currently holding picks. */
  IN_USE = 'IN_USE',
  /** A PACK that was broken to loose stock (no longer a unit). */
  CONSUMED = 'CONSUMED',
}
